import { breakpoints } from '@shopify/editor-core';
import { MediaQueryTarget } from './types.mjs';

const MIN_WIDTH = {
  phablet: breakpoints.phablet,
  tablet: breakpoints.tablet,
  desktop: breakpoints.desktop,
  widescreen: breakpoints.widescreen
};
const MAX_WIDTH = {
  // `Mobile` should simply be when `Phablet` does not match.
  mobile: `${parseInt(breakpoints.phablet, 10) - 1}px`,
  // `MobileCommon` is a snowflake and should be replaced.
  mobileCommon: `${parseInt(breakpoints.mobileCommon, 10) - 1}px`
};
const mediaQueries = {
  [MediaQueryTarget.Phablet]: `(min-width: ${MIN_WIDTH.phablet})`,
  [MediaQueryTarget.Tablet]: `(min-width: ${MIN_WIDTH.tablet})`,
  [MediaQueryTarget.Desktop]: `(min-width: ${MIN_WIDTH.desktop})`,
  [MediaQueryTarget.Widescreen]: `(min-width: ${MIN_WIDTH.widescreen})`,
  [MediaQueryTarget.Landscape]: '(orientation: landscape)',
  [MediaQueryTarget.PrefersReducedMotion]: '(prefers-reduced-motion: reduce)',
  // Candidates for removal
  [MediaQueryTarget.Mobile]: `(max-width: ${MAX_WIDTH.mobile})`,
  [MediaQueryTarget.MobileCommon]: `(max-width: ${MAX_WIDTH.mobileCommon})`
};

export { mediaQueries };
